import React, { useCallback, useEffect, useState } from 'react';
import { withChoreographedRender } from '@atlassian/jira-choreographer-services/src/withChoreographedRender.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import { JSM_HR_EXPANSION_SPOTLIGHT_MESSAGE } from './common/constants';
import { HrExpansionSpotlightView } from './ui';

const HrExpansionSpotlightWithDelay = () => {
	const [shouldShowSpotlight, setShouldShowSpotlight] = useState<boolean>(false);

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			setShouldShowSpotlight(true);
		}, 2000);
		return () => clearTimeout(timeoutId);
	}, []);
	return shouldShowSpotlight && <HrExpansionSpotlightView />;
};

const ChoreographedCustomMessageComponent = withChoreographedRender(HrExpansionSpotlightWithDelay);

const ChoreographedHrSpotlight = () => (
	<ChoreographedCustomMessageComponent messageId={JSM_HR_EXPANSION_SPOTLIGHT_MESSAGE} />
);

export const HrExpansionSpotlight = () => {
	const emptyFallback = useCallback(() => <></>, []);
	return (
		<JSErrorBoundary
			id="jira-servicedesk-hr-expansion-experiment-spotlight"
			packageName="jiraServicedeskHrExpansionExperiment"
			teamName="jsd-getting-started"
			fallback={emptyFallback}
		>
			<ChoreographedHrSpotlight />
		</JSErrorBoundary>
	);
};
